module.exports = __webpack_public_path__ + "img/welc.1f19ef54.jpg";